Intl = require 'intl'
{ currentLocale } = require '@trello/locale'

formatter = null
module.exports = (num) ->
  formatter ?= new Intl.NumberFormat(currentLocale)
  formatter.format(num)
